import * as types from './constants';

// Lookbook Manage Flow
export const lookbookManageFlowShowPreview = data => (
	{ type: types.LOOKBOOK_MANAGE_FLOW_SHOW_PREVIEW, payload: data }
);

export const lookbookManageFlowSetProp = data => (
  { type: types.LOOKBOOK_MANAGE_FLOW_SET_PROP, payload: data }
);

export const lookbookManageFlowSetData = data => (
  { type: types.LOOKBOOK_MANAGE_FLOW_SET_DATA, payload: data }
);

export const lookbookManageFlowSetUnsavedChanges = data => (
  { type: types.LOOKBOOK_MANAGE_FLOW_SET_UNSAVED_CHANGES, payload: data }
);

// Merges Shopify stock numbers, keyed by `sid`, into whatever offers are in the store right now.
// Deliberately not a `lookbookManageFlowSetProp({ prop: 'offers' })` from the component: every offer
// row fetches its own stock on mount, so a whole-array replace computed in the component would be
// built from the offers as they were when that row mounted and would wipe the other rows' results.
export const lookbookManageFlowApplyStock = stockBySid => (
  { type: types.LOOKBOOK_MANAGE_FLOW_APPLY_STOCK, payload: stockBySid }
);

// Merges a thumbnail (from getLinkMetaSaga or a manual upload) into the given variants of `offerId`,
// keyed by variant id, against whatever offers are in the store right now. Deliberately not a
// `lookbookManageFlowSetProp({ prop: 'offers' })` from the component: this always resolves
// asynchronously (a link-meta fetch, an image upload), by which point a component-built whole-array
// replace would be based on a stale snapshot of `offers` and would silently undo any edit made since
// (e.g. the URL save that triggered the fetch in the first place) - same class of bug as
// lookbookManageFlowApplyStock above (SIBD-13343).
export const lookbookManageFlowSetVariantImage = ({ offerId, variantIds, imageUrl, imageUploadId, offerImageUploadId }) => (
  { type: types.LOOKBOOK_MANAGE_FLOW_SET_VARIANT_IMAGE, payload: { offerId, variantIds, imageUrl, imageUploadId, offerImageUploadId } }
);

export const lookbookManageFlowClear = () => (
  { type: types.LOOKBOOK_MANAGE_FLOW_CLEAR }
);

export const lookbookManageFlowSetErrors = errors => (
  { type: types.LOOKBOOK_MANAGE_FLOW_SET_ERRORS, payload: errors }
);

export const lookbookManageFlowClearError = prop => (
  { type: types.LOOKBOOK_MANAGE_FLOW_CLEAR_ERROR, payload: prop }
);

export const lookbookManageFlowClearErrors = () => (
  { type: types.LOOKBOOK_MANAGE_FLOW_CLEAR_ERRORS }
);
